export enum ErrorMessages {
  overQueryLimit = 'overQueryLimit',
  requestDenied = 'requestDenied',
  unknownError = 'unknownError',
  zeroResults = 'zeroResults',
  invalidRequest = 'invalidRequest',
  notFound = 'notFound',
  ok = 'ok',
  error = 'error',
  maxWaypointsExceeded = 'maxWaypointsExceeded',
  notLoadingAPIFromGoogleMapsError = 'notLoadingAPIFromGoogleMapsError',
  tOSViolationMapError = 'tOSViolationMapError',
  unauthorizedURLForClientIdMapError = 'unauthorizedURLForClientIdMapError',
  apiNotActivatedMapError = 'apiNotActivatedMapError',
  apiTargetBlockedMapError = 'apiTargetBlockedMapError',
  deletedApiProjectMapError = 'deletedApiProjectMapError',
  billingNotEnabledMapError = 'billingNotEnabledMapError',
  expiredKeyMapError = 'expiredKeyMapError',
  invalidClientIdMapError = 'invalidClientIdMapError',
  invalidKeyMapError = 'invalidKeyMapError',
  malformedCredentialsMapError = 'malformedCredentialsMapError',
  missingKeyMapError = 'missingKeyMapError',
  projectDeniedMapError = 'projectDeniedMapError',
  refererDeniedMapError = 'refererDeniedMapError',
  refererNotAllowedMapError = 'refererNotAllowedMapError',
  overQuotaMapError = 'overQuotaMapError',
  apiProjectMapError = 'apiProjectMapError',
  clientIdLooksLikeCryptoKey = 'clientIdLooksLikeCryptoKey',
  clientIdLooksLikeKey = 'clientIdLooksLikeKey',
  invalidChannel = 'invalidChannel',
  invalidClientId = 'InvalidClientId',
  invalidKey = 'invalidKey',
  InvalidVersion = 'invalidVersion',
  keyLooksLikeClientId = 'keyLooksLikeClientId',
  keyLooksLikeCryptoKey = 'keyLooksLikeCryptoKey',
  keyLooksLikeProjectNumber = 'keyLooksLikeProjectNumber',
  noApiKeys = 'noApiKeys',
  retiredVersion = 'retiredVersion',
  sensorNotRequired = 'sensorNotRequired',
  signatureNotRequired = 'signatureNotRequired',
  signedInNotSupported = 'signedInNotSupported',
  urlAuthenticationCommonError = 'urlAuthenticationCommonError',
}
